// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__5ovla","FooterMenuclass":"footer_FooterMenuclass__5sAHG"};